/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RateMasterFormat {
    Expedite = 90,
    Tier = 80,
    Accessorial = 99,
}
